// Replace our chirp module `type` with the our internal CMv2 type

export const isGridLayoutModule = module => {
  return 'grid_layout_id' in module;
};